import React, { useEffect, useState } from 'react'
import { PhoneInput } from 'react-international-phone'
import 'react-international-phone/style.css'

import { Container } from './PhoneField.styled'

function PhoneField({ value, fieldName, placeholder, defaultCountry, onChange, onClick }) {
  const [focused, setFocused] = useState(false)

  const handleFocuse = () => setFocused(true)

  const handleBlur = () => setFocused(false)

  const handleChange = (phone) => onChange({ name: fieldName, value: phone })

  return (
    <Container
      className="phone-field-wrapper"
      focused={focused}
      onFocus={handleFocuse}
      onBlur={handleBlur}
      onClick={onClick}
    >
      <PhoneInput
        {...(value && { value })}
        name={fieldName}
        defaultCountry={defaultCountry}
        placeholder={placeholder || 'Contact phone'}
        onChange={handleChange}
      />
    </Container>
  )
}

export default PhoneField
